const scrollToEl = (e, checkHash) => {
  const scrollToEl = document
    .getElementById(e.target.hash.replace("#", ""))
    .getBoundingClientRect();
  window.scrollTo({
    top: scrollToEl.top + window.pageYOffset - 93,
    behavior: "smooth",
  });
  e.preventDefault();
  if (checkHash) {
    window.history.pushState(null, null, e.target.hash);
  }
};
export default scrollToEl;
